/**
 * @generated SignedSource<<91d488c1adc3103d545a4265f057f0a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "StatusImpulseResponse",
    "kind": "LinkedField",
    "name": "statusImpulse",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "card",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationStatusImpulseImplQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationStatusImpulseImplQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1e47d708cfb50168f12729cd2dbc9f70",
    "id": null,
    "metadata": {},
    "name": "IntegrationStatusImpulseImplQuery",
    "operationKind": "query",
    "text": "query IntegrationStatusImpulseImplQuery(\n  $request: StatusImpulseRequestInput\n) {\n  statusImpulse(request: $request) {\n    card\n    status\n  }\n}\n"
  }
};
})();

node.hash = "68dcae3cbd120cf9ca863afc0f046360";

module.exports = node;
